// extracted by mini-css-extract-plugin
export default {"modal":"SelectPushStaff_modal__ReCY9","tips":"SelectPushStaff_tips__K-Px4","channel_title":"SelectPushStaff_channel_title__N-w2S"};